var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundLines2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 347,
    viewBox: "0 0 234 347",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.7772 359V234.389C79.7772 226.615 73.4751 220.313 65.701 220.313H-6.63244C-13.9206 220.313 -19.8289 214.405 -19.8289 207.117V78.8846C-19.8289 71.1105 -26.131 64.8084 -33.9051 64.8084L-77.0001 64.8084",
    stroke: "url(#paint0_linear_16849_10158)",
    strokeWidth: 0.528459
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-40.1481 132.891L16.4037 132.891C23.6919 132.891 29.6001 138.799 29.6001 146.087V257.734C29.6001 265.022 35.5083 270.93 42.7965 270.93H229.684",
    stroke: "url(#paint1_linear_16849_10158)",
    strokeWidth: 0.528459
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.684 -42V45.4455H79.7771V-27.9238C79.7771 -35.6979 73.475 -42 65.7009 -42H-20.1606",
    stroke: "url(#paint2_linear_16849_10158)",
    strokeWidth: 0.528459
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.684 133.516H192.911C185.623 133.516 179.715 127.607 179.715 120.319V-42",
    stroke: "url(#paint3_linear_16849_10158)",
    strokeWidth: 0.528459
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.4128 37.3256H33.5977V111.47C33.5977 118.758 39.5059 124.667 46.7941 124.667H133.619V211.592H233.431",
    stroke: "url(#paint4_linear_16849_10158)",
    strokeWidth: 0.528459
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16849_10158",
    x1: 93.4664,
    y1: 334.989,
    x2: -56.4755,
    y2: 44.2705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375941,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727934,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16849_10158",
    x1: 253.244,
    y1: 259.664,
    x2: 229.433,
    y2: 90.3161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375941,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727934,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_16849_10158",
    x1: 251.499,
    y1: 38.3086,
    x2: 241.071,
    y2: -70.0884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375941,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727934,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_16849_10158",
    x1: 234.047,
    y1: 119.191,
    x2: 124.324,
    y2: 5.53843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375941,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727934,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_16849_10158",
    x1: 255.247,
    y1: 197.369,
    x2: 214.932,
    y2: -12.9209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375941,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727934,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLines2);
export default __webpack_public_path__ + "static/media/background-lines-2.f540a57bdc0baf534baf9142f388a765.svg";
export { ForwardRef as ReactComponent };